export const getStyles = () => ({
  creativeEditor: {
    '& .left-panel': {
      position: 'absolute',
      top: 60,
      left: 0,
      bottom: 64,
      width: 480,
      backgroundColor: 'white',
      padding: '0 24px',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      zIndex: 4,
      overflow: 'auto',

      '& .panel-description': {
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 400,
        marginTop: 28,
      },
      '& .item-title': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      },
      '& .text-item': {
        display: 'grid',
        alignItems: 'end',
        gridTemplateColumns: '90% 10%',
        gridGap: '10px',
      },
      '& .text-container': {
        marginTop: 16,
        '& .text-title': {
          fontSize: 12,
          lineHeight: '16px',
          fontWeight: 600,
        },
        '& .text-field': {
          width: '100%',
          marginTop: 8,
        },
      },
      '& .generate-creative-button': {
        marginTop: 32,
        borderRadius: 4,
        border: '1px solid #D1D1D1',
      },
    },

    '& .preview-container': {
      backgroundColor: '#FAF9F8',
      paddingLeft: 32,
      position: 'absolute',
      top: 60,
      right: 0,
      left: 480,
      bottom: 64,
      zIndex: 2,
      overflowX: 'auto',
      '& .preivew-box': {
        height: 'calc(100% - 150px)',
        '& .loading-box': {
          width: '100%',
          height: '100%',
          '& .loading-placeholder': {
            width: 679,
            height: 'calc(100% - 52px)',
            borderRadius: '6px',
            background: '#EDEBE9',
          },
          '& .spinner-box': {
            marginTop: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .spinner-text': {
              marginLeft: 8,
              fontSize: 16,
              fontstyel: 'normal',
              fontweight: 400,
              lineHeight: '22px',
              color: '#605E5C',
            },
          },
        },
        '& .preview-image': {
          width: 679,
          height: '100%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& img': {
            width: 'auto',
            height: 'auto',
            maxWidth: 679,
            maxHeight: '100%',
            objectFit: 'contain',
          },
        },
      },
      '& .message-bar': {
        position: 'absolute',
        bottom: 160,
      },
    },
    '& .creative-color-editor-container': {
      position: 'relative',
      '& .creative-color-editor-elements': {
        position: 'absolute',
        top: '10px',
        right: '10px',
        zIndex: 1000,
        '& .creative-color-swatch': {
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          width: 'auto',
          boxShadow: '0px 16px 32px 0px #00000024',
          borderRadius: '8px',
          padding: '16px',
          '& .eye-dropper': {
            width: '24px',
            height: '24px',
            backgroundColor: '#E0E0E0',
            borderRadius: '4px',
            border: '1px solid #B3B3B3',
          },
          '& .close-swatch': {
            width: '24px',
            height: '24px',
          },
          '& .close-swatch:hover': {
            cursor: 'pointer',
            border: '1px solid #5e5e5e',
          },
          '& .eye-dropper:hover': {
            cursor: 'pointer',
            border: '1px solid #5e5e5e',
          },
        },
      },
    },
    '& .creative-color-icon-container': {
      borderRadius: '4px',
      marginRight: '8px',
      '& .creative-color-icon': {
        height: '32px',
        width: '32px',
        borderRadius: '4px',
        border: '1px solid gray',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    '& .color-picker-container': {
      width: '300px',
      '& .color-picker': {
        boxShadow: '0px 16px 32px 0px #00000024',
        borderRadius: '4px',
        marginTop: '8px',
        backgroundColor: 'white',
      },
    },
    '& .selected-color': {
      boxShadow: 'inset 0 0 0 2px #0078D4',
    },
  },
});
